import { render, staticRenderFns } from "./FormArbo.vue?vue&type=template&id=7485ae56&"
import script from "./FormArbo.vue?vue&type=script&lang=js&"
export * from "./FormArbo.vue?vue&type=script&lang=js&"
import style0 from "./FormArbo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports